export default __webpack_public_path__ + "static/media/abel.f9ae89f9.jpeg";